import React from 'react';
import PaginationComponent from '@/components/common/PaginationComponent';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange, 
  pageSize = 10,
  totalItems,
  className = ''
}) => {
  return (
    <PaginationComponent
      currentPage={currentPage}
      totalPages={totalPages}
      totalItems={totalItems}
      pageSize={pageSize}
      onPageChange={onPageChange}
      className={className}
    />
  );
};

export default Pagination;